module.exports = __webpack_public_path__ + "media/images/code-7f05ba78dd18e293bf99eb4cb18217f0.png";